// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"776d1f54","515":"2f153e12","860":"fac3bcf9"}[chunkId] + ".chunk.js";
};